/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect } from "react";
import { IXsollaPaystationProps } from "interfaces";
import { isJsonString } from "utils/isJsonString";
import { getDebugLogger } from "utils/debugLogger";

const debug = getDebugLogger({
	isEnabled: true,
	color: "#8E44AD"
});

interface UseXsollaMessageListenerParams {
	source?: string;
	onPurchaseStarted?: (args: { payStation?: string; data?: any }) => void;
	onSuccess?: (data: any) => void;
	onFailure?: () => void;
	onCreateInvoice?: () => void;
	onFinish?: () => void;
}

export const useXsollaMessageListener = ({
	source,
	onPurchaseStarted,
	onSuccess,
	onFailure,
	onCreateInvoice,
	onFinish
}: UseXsollaMessageListenerParams) => {
	useEffect(() => {
		/* eslint-disable-next-line */
		const handleMessageEvent = (event: any) => {
			if (!event.origin.toLowerCase().includes("xsolla")) {
				return;
			}

			const eventData: IXsollaPaystationProps =
				event?.data && isJsonString(event.data)
					? JSON.parse(event.data)
					: event.data;

			if (eventData?.command === "open-paystation") {
				if (typeof onPurchaseStarted !== "undefined") {
					onPurchaseStarted({
						payStation: eventData?.data?.version,
						data: eventData?.data
					});
				}
			}

			if (
				eventData?.action === "complete" ||
				eventData?.data?.action === "open-status-success" // Xsolla v4
			) {
				if (typeof onSuccess !== "undefined") {
					onSuccess(eventData?.data);
				}
			}

			if (
				eventData?.data?.paymentInfo?.status === "troubled" ||
				eventData?.command === "error" ||
				eventData?.command === "open-status-error"
			) {
				if (typeof onFailure !== "undefined") {
					onFailure();
				}
			}

			debug.logUseEffect({
				iconText: "DialogXsollaPurchase",
				message: [
					"handleMessageEvent:",
					"origin",
					event.origin,
					"eventData",
					eventData
				]
			});
			if (eventData?.data?.action === "create-invoice") {
				if (typeof onCreateInvoice !== "undefined") {
					onCreateInvoice();
				}
			}

			if (eventData?.data?.action === "show-error-page") {
				console.log(
					"XsollaPostMessage: show-error-page ACTION",
					"eventData:",
					eventData
				);
			}

			if (eventData?.action === "finish" || eventData?.command === "return") {
				console.log(
					"XsollaPostMessage: FINISH",
					`${eventData?.action} === "finish" ||
				    ${eventData?.command} === "return"`
				);

				if (typeof onFinish !== "undefined") {
					onFinish();
				}
			}
		};
		window.addEventListener("message", handleMessageEvent, false);
		return () => {
			window.removeEventListener("message", handleMessageEvent, false);
		};
	}, [
		source,
		onPurchaseStarted,
		onSuccess,
		onFailure,
		onCreateInvoice,
		onFinish
	]);
};
